export default __webpack_public_path__ + "static/subclass-arc-cdd5d1.png";